import React, { useState, useEffect } from 'react';
// import FliterBlock from '../../common/filterBlock/Filter';
import InfiniteScroll from "react-infinite-scroll-component";
import { apis } from '../../services/Api';
import Card from '../../common/card/Card'
import { connect } from 'react-redux';
import { useLocation } from "react-router-dom";
import './MyLearnings.css';

function MyLearning(props) {

    let [myLearningList, setMyLearningList] = useState([]);
    let [hasMore, setHasMore] = useState(true);
    let [cursor, setCursor] = useState();
    const location = useLocation();

    useEffect(() => {
        apiCall()
    }, []);

    const apiCall = async (c) => {
        let { links, data, included } = await apis.getEnrollments(10, c);
        if (!links.next) {
            setHasMore(false);
        } else {
            const urlParams = new URLSearchParams(links.next);
            const nextCursor = urlParams.get('page[cursor]');
            setCursor(nextCursor);
        }
        for (let i = 0; i < data.length; i++) {
            for (let y = 0; y < included.length; y++) {
                if (data[i].relationships.learningObject.data.id === included[y].id) {
                    setMyLearningList(oldArray => [...oldArray, {
                        id: included[i].id,
                        enrollmentSource: data[i].attributes.enrollmentSource,
                        progressPercent: data[i].attributes.progressPercent,
                        loFormat: included[i].attributes.loFormat,
                        name: included[i].attributes.localizedMetadata[0].name,
                        overview: included[i].attributes.localizedMetadata[0].overview,
                        imageUrl: included[i].attributes.imageUrl,
                        duration: included[i].attributes.duration,
                        averageRating: included[i].attributes.rating.averageRating,
                        skills: findSkill(included[i].relationships.skills.data[0].id.split('_')[1])?.name || ''
                    }]);
                }
            }
        }
    }

    const findSkill = (id) => {
        return props.skills.find((e) => {
            return e.id === id
        })
    }

    const nextCursor = () => {
        apiCall(cursor);
    }

    const playCourse = (cid, mid) => {
        props.history.push({
            pathname: `/course-player`,
            state: {
                cid,
                mid,
                goBackUrl: location.pathname
            }
        });
    }

    return (
        <React.Fragment>
            <div className='main-block'>
            <div className='container'>
                <div className='catalog-listview-block'>
                    <InfiniteScroll
                        dataLength={myLearningList.length}
                        next={() => nextCursor()}
                        hasMore={hasMore}
                        loader={<h4>Loading...</h4>}
                        className="catalog-block"
                        endMessage={<p style={{ textAlign: "center" }}></p>}
                    >
                        {myLearningList.map((e) => <Card key={e.id} data={e} playCourse={playCourse} />)}

                    </InfiniteScroll>
                </div>
            </div>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        skills: state.skills
    }
}
export default connect(mapStateToProps)(MyLearning);